import React from 'react';
import styled from 'styled-components';
import Hero from '../components/Hero';
import About from '../components/About';
import Mission from '../components/Mission';
import Values from '../components/Values';
import Team from '../components/Team';

const HomeContainer = styled.main`
  min-height: 100vh;
`;

const Home = () => {
  return (
    <HomeContainer>
      <Hero />
      <About />
      <Mission />
      <Values />
      <Team />
    </HomeContainer>
  );
};

export default Home;
